import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Row, Col, Form, Container } from "react-bootstrap";
import { setHeading } from "../../../accounts/account.actions";
import { GetPaymentReportApi } from "./PaymentReceivingAction";
import { isEmpty } from "lodash";
import { getUserRes } from "../../AddUser/user.actions";
import { GlobalSpinner } from "../../../../../global/globalFunctions";
import { GetAreaApi } from "../AddArea/areaAction";
import moment from "moment";
import Select from "react-select";
import SendIcon from '@mui/icons-material/Send';
import Button from '@mui/material/Button';


const PaymentReports = (props) => {
    const [startDate, setStartDate] = useState(moment().format("YYYY-MM-DD"));
    const [endDate, setEndDate] = useState(moment().format("YYYY-MM-DD"));
    const [areaName, setAreaName] = useState("");
    const [areaId, setAreaId] = useState();
    const [bookerId, setBookerId] = useState("");
    const [bookerName, setBookerName] = useState("");


    function PrintPDF() {
        props.GetPaymentReportApi({
            startDate: startDate,
            endDate: endDate,
            areaId: areaId,
            bookerId: bookerId,
            bookerName: bookerName,
            areaName: areaName,
        })
    }

    const handleChangeArea = (selectedOption) => {
        setAreaId(selectedOption.value);
        setAreaName(selectedOption.label);
        props.GetShopByAreaApi(selectedOption.value);
    };
    const AreaListData = !isEmpty(props.areaDataList) && props.areaDataList.map((x) => {
        let data = { value: x._id, label: x.areaName };
        return data;
    });


    const handleChangeBooker = (selectedOption) => {
        setBookerId(selectedOption.value);
        setBookerName(selectedOption.label);
    };
    const filterdUserList = !isEmpty(props.userList) && props.userList.filter((e) => e.role === "booker");
    const BookerList = !isEmpty(filterdUserList) && filterdUserList.map((x) => {
        let data = { value: x._id, label: x.userName };
        return data;
    });


    useEffect(() => {
        props.setHeading("Payment Report");
        props.GetAreaApi();
        props.getUserRes()
    }, []);

    return (
        <>
            {props.isFetchingAreaData || props.isFetchingUser ? (
                <GlobalSpinner />
            ) : (
                <Container fluid>
                    <Row>
                        <Col >
                            <Form.Group className="mb-3" controlId="garana">
                                <Form.Label><b>Start Date *</b></Form.Label>
                                <Form.Control
                                    type="date"
                                    value={startDate}
                                    onChange={(e) => setStartDate(e.target.value)}
                                ></Form.Control>
                            </Form.Group>
                        </Col>
                        <Col >
                            <Form.Group className="mb-3" controlId="garana">
                                <Form.Label><b>End Date *</b></Form.Label>
                                <Form.Control
                                    type="date"
                                    value={endDate}
                                    onChange={(e) => setEndDate(e.target.value)}
                                ></Form.Control>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Form.Group className="mb-3" controlId="garana">
                                <Form.Label><b>Select DSF *</b></Form.Label>
                                <Select
                                    placeholder="Select DSF"
                                    onChange={handleChangeBooker}
                                    options={BookerList}
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="garana">
                                <Form.Label> <b>Select Area *</b> </Form.Label>
                                <Select
                                    placeholder="Select Area"
                                    onChange={handleChangeArea}
                                    options={AreaListData}
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    <div className="sendDiv">
                        {isEmpty(startDate) || isEmpty(endDate) ? (
                            <Button variant="contained" endIcon={<SendIcon />} size="large" disabled> PRINT REPORT </Button>
                        ) : (
                            <Button variant="contained" endIcon={<SendIcon />} size="large" onClick={PrintPDF}> PRINT REPORT </Button>
                        )}
                    </div>

                </Container>
            )}
        </>
    );
};
const mapDispatchToProps = (dispatch) => {
    return {
        GetAreaApi: () => dispatch(GetAreaApi()),
        getUserRes: () => dispatch(getUserRes()),
        setHeading: (data) => dispatch(setHeading(data)),
        GetPaymentReportApi: (data) => dispatch(GetPaymentReportApi(data)),
    };
};
const mapStateToProps = (state, ownProps) => ({
    isFetchingAreaData: state.AreaReducer.isFetchingAreaData,
    areaDataList: state.AreaReducer.areaDataList,
    isFetchingUser: state.UserReducer.isFetchingUser,
    userList: state.UserReducer.userList,
});

export default connect(mapStateToProps, mapDispatchToProps)(PaymentReports);
